export const offeringCategory = {
  NORMAL: {
    label: 'Standard',
    value: 0,
  },
  CONDITIONAL: {
    label: 'Conditional',
    value: 1,
  },
  COMING_SOON: {
    label: 'Coming Soon',
    value: 2,
  },
  TESTING_WATERS: {
    label: 'Testing the Waters',
    value: 3,
  },
};

export default {
  offeringCategory,
};



// WEBPACK FOOTER //
// ./src/helpers/mappings.js